<template>
	<api-error v-for="err in errors" :level="err.level" :message="err.message" style="margin-bottom:4px"></api-error>
	<array-part :part="part" :data="data" :readonly="readonly" :viewmode="viewmode"></array-part>
</template>

<script setup lang="ts">
import ArrayPart from "../../containers/ArrayPart.vue";
import {type PartProps, partProps} from "../../Part";
import type {Relations} from "@t/fd/layout/Relations";
import ApiError from "@fd/helpers/ApiError.vue";
import useContainer from "@fd/containers/Container.ts";

const uprops = defineProps({...partProps});
const props = uprops as PartProps;

const {errors} = useContainer(props);
</script>

<style>
</style>
